import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import LineItemsList from '../LineItemsBreakdownList'
import SkeletonLineItemsBreakdown from '../Skeleton'
import SectionWrapper from '../../SectionWrapper'

import {
  combinedLineItemsErrorSelector,
  combinedLineItemsIsLoadingSelector,
  combinedLineItemsSelector,
  combinedLineItemsWasLoadedSelector
} from '../../../../../../modules/selectors/combinedData'

import useStyles from '../styles'

const GoogleAdGroupBreakdown = ({ campaigns }) => {
  const classes = useStyles()

  const combinedLineItems = useSelector(combinedLineItemsSelector)
  const combinedLineItemsIsLoading = useSelector(combinedLineItemsIsLoadingSelector)
  const combinedLineItemsError = useSelector(combinedLineItemsErrorSelector)
  const combinedLineItemsWasLoaded = useSelector(combinedLineItemsWasLoadedSelector)

  if (combinedLineItemsIsLoading || !combinedLineItemsWasLoaded) {
    return <SkeletonLineItemsBreakdown />
  } else if (combinedLineItemsError || !combinedLineItems.length) {
    return null
  }

  return (
    <SectionWrapper title={'Ad groups'}>
      <ul className={classes.listWrapper}>
        {campaigns.map((campaign, index) => (
          <LineItemsList key={campaign.campaign_id} campaign={campaign} index={index} nameColumnLabel={'Ad group'} />
        ))}
      </ul>
    </SectionWrapper>
  )
}

GoogleAdGroupBreakdown.propTypes = {
  campaigns: PropTypes.array.isRequired
}

export default GoogleAdGroupBreakdown
